export const APP_NAME = import.meta.env.VITE_APP_NAME || 'KallcyHRMS';
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api/v1';
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || '1.0.0';

export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

export const DATE_FORMAT = 'dd MMM yyyy';
export const DATETIME_FORMAT = 'dd MMM yyyy HH:mm';
